module.exports = __webpack_public_path__ + "img/konversi_mata_uang.6b2013db.svg";